import {useLayoutEffect, useRef, useState, useCallback} from 'react';

export default function useVerticalRovingFocus(
  containerRef,
  enabled,                 //  <-- NEW
  deps = []
) {
  const itemsRef          = useRef([]);
  const [current, setCurrent] = useState(0);

  /* -------------------------------------
     Build (or clear) the focusable list
  ------------------------------------- */
  useLayoutEffect(() => {
    if (!enabled) {
      // Drawer closed: make everything untabbable & forget the list
      itemsRef.current.forEach(el => (el.tabIndex = -1));
      itemsRef.current = [];
      return;
    }

    if (!containerRef.current) return;

    // In some cases the children are not in the DOM yet
    // One micro-task delay guarantees they are
      if (!containerRef.current) return;

      itemsRef.current = Array.from(
        containerRef.current.querySelectorAll('[data-nav-item]')
      );

      if (itemsRef.current.length === 0) return;

      // Reset to the first item and focus it
      setCurrent(0);
    
  }, [enabled, containerRef, ...deps]);

  /* -------------------------------------
     Move focus when `current` changes
  ------------------------------------- */
  useLayoutEffect(() => {
    if (!enabled || itemsRef.current.length === 0) return;

    itemsRef.current.forEach((el, i) => (el.tabIndex = i === current ? 0 : -1));
    itemsRef.current[current]?.focus();
  }, [enabled, current]);

  /* -------------------------------------
     Arrow‑key handler (does nothing when
     the drawer is closed)
  ------------------------------------- */
  const onKeyDown = useCallback(
    e => {
      if (!enabled) return;

      const max = itemsRef.current.length;
      if (max === 0) return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        setCurrent(i => (i + 1) % max);
      }
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        setCurrent(i => (i - 1 + max) % max);
      }
    },
    [enabled]
  );

  return {onKeyDown};
}
